import React from "react";

const Tag = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M13 22l9-9L10 1H1v9z" />
      <circle cx={7} cy={7} r={2} />
    </g>
  </svg>
);

export default Tag;



// WEBPACK FOOTER //
// ./src/theme/icons/Tag.js